import { AnimatePresence, motion } from 'motion/react';
import { Ref } from 'react';

import Button, {
  ButtonSize,
  ButtonVariant,
} from '@/components/BaseLibrary/Button/Button';
import Icon, { IconName } from '@/components/Icon/Icon';
import useSunrunShopStore, {
  useSunrunShopActions,
} from '@/data-store/hooks/useSunrunShopStore';
import { CartActions } from '@/data-store/slices/sunrunShopSlice';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './Cart.styles';

export default function CartHeader({
  mode = 'default',
}: {
  mode?: 'empty' | 'default';
}) {
  const { classes } = useStyles();
  const { setIsCartOpen } = useSunrunShopActions();

  const closeCart = () => setIsCartOpen(false);

  return (
    <div className={classes.header}>
      {mode === 'empty' && <h3 aria-label='Cart is empty' />}
      {mode === 'default' && <CartHeaderHeading />}

      <Button
        iconName={IconName.CLOSE}
        variant={ButtonVariant.TERTIARY}
        size={ButtonSize.SM}
        onClick={closeCart}
      />
    </div>
  );
}

const CartHeaderHeading = () => {
  const { cartAction } = useSunrunShopStore('cartAction');

  return (
    <AnimatePresence mode='wait'>
      {cartAction === CartActions.ADD_ITEM && <AddItemText key='#' />}
      {cartAction !== CartActions.ADD_ITEM && <DefaultCartHeading key='@' />}
    </AnimatePresence>
  );
};

const DefaultCartHeading = ({ ref }: { ref?: Ref<HTMLDivElement> }) => {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <motion.h3
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeIn' }}
      className={cx(globalClasses.h3, classes.cartHeaderHeading)}
    >
      Your Cart
    </motion.h3>
  );
};

const AddItemText = ({ ref }: { ref?: Ref<HTMLDivElement> }) => {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <motion.h3
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className={cx(globalClasses.h3, classes.cartHeaderHeading)}
    >
      <Icon name={IconName.CHECK} width={32} /> Added to Cart
    </motion.h3>
  );
};
